import { Upload } from '@aws-sdk/lib-storage'
import { S3, S3Client } from '@aws-sdk/client-s3'
import { config } from '../config-amplify'
import { v4 as uuidv4 } from 'uuid'
import { S3 as s3 } from "aws-sdk";
import { saveAs } from 'file-saver'

let credentials : any = {
    accessKeyId: process.env.REACT_APP_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_SECRET_KEY
}

export const uploadToS3 = async (file, s3Info: {value: any}, url: string | undefined, tenantId?: string, bucket = process.env.REACT_APP_S3_URL) : Promise<void> => {
    const target = {Bucket: bucket, Key: url?.replace(/^http.+\.com\//, "") || `${tenantId}/${uuidv4()}_${file.name}`, Body: file}

    try {
        const uploadS3 = new Upload({
            client: new S3Client({region: config.REGION, credentials}),
            leavePartsOnError: false,
            params: target
        })

        uploadS3.on('httpUploadProgress', (progress) => {
            s3Info.value = progress
        })
        await uploadS3.done()

    } catch (err) {
        console.log("error", err)
        throw err
    }
}

export const uploadDynamicFile = async (file, key?: string, bucket = process.env.REACT_APP_S3_URL) => {
    const target = {Bucket: bucket, Key: key, Body: file}

    console.log("FILE", file)

    try {
        const uploadS3 = new Upload({
            client: new S3Client({region: config.REGION, credentials}),
            leavePartsOnError: false,
            params: target
        })

        uploadS3.on('httpUploadProgress', (progress) => {
            // s3Info.value = progress
        })
        await uploadS3.done()

    } catch (err) {
        console.log("error", err)
        throw err
    }
}

export const deleteToS3 = async (name, bucket = process.env.REACT_APP_S3_URL) => {
    let target = { Bucket: bucket, Key: name?.replace(/^http.+\.com\//, "") };
    let s3Bucket = new S3({
        region: config.REGION,
        credentials
    })

    try {
        await s3Bucket.deleteObject(target)
    } catch (err) {
        throw err
    }
}

export const getJsonFromS3 = async (subFolder = "", valueFolder = "DashboardStats.json") : Promise<any> => {
    const bucketParams : any = {
        Bucket: process.env.REACT_APP_S3_URL_DOCS,
        Key: `${subFolder}/${valueFolder}`
    }   
    // return new S3({region: config.REGION, credentials}).getObject(bucketParams, async (err, data) => {
    //     console.log("RESPONSE ()", data)
    //     console.log("RESPONSE JSON", JSON.parse(data.Body.toString("utf-8")))
    //     //@ts-ignore
    //     return await JSON.parse(data.Body.toString("utf-8"))
    // })
    let data = await new s3({region: config.REGION, credentials}).getObject(bucketParams).promise()
    return JSON.parse(data.Body?.toString("utf-8") || "")
    // let response = await s3.getObject({Bucket: bucketParams.})
    // let response = await new S3Client({region: config.REGION, credentials}).send(new GetObjectCommand(bucketParams))
    // return await response
}


export const downloadImage = async (url) => {
    let key = url.replace(/https.+\.com\//, "")

    let s3Bucket = new s3({
        region: config.REGION,
        credentials
    })
    // let news3 = new s3({ params: { Bucket: "nevula-docs-bucket-test-12db7f23c30b" }})
    let params = {Bucket: process.env.REACT_APP_S3_URL_DOCS, Key: key}

    let signedUrl = s3Bucket.getSignedUrl("getObject", params)

    const response = await fetch(signedUrl);
    const data = await response.blob();
    saveAs(data, key)
    // let mimeType = data.type || "application/octet-stream";
    // let link = document.createElement('a');
    // link.href = window.URL.createObjectURL(data);
    // link.download = url;
    // link.click();
  }

  export const getFilesFromBucket = async (key: string, valueToFilter: string) => {
    let s3Bucket = new s3({
        region: config.REGION,
        credentials
    })
    let params = {Bucket: process.env.REACT_APP_S3_URL_DOCS as string, Prefix: `${key}/${valueToFilter}`}
    const resp = await s3Bucket.listObjectsV2(params).promise()
    
    return resp.Contents?.map((v: any) => returnRegex(v?.Key as string, valueToFilter as any))
  }

  /** Metodo optimizado para obtener archivos desde s3 */
  export const onGetFileFromS3 = async (key: string) => {
    const s3Instance = new s3(credentials);
  
    const { Body } = await s3Instance
      .getObject({
        Bucket: process.env.REACT_APP_S3_URL_DOCS!,
        Key: key,
      })
      .promise();
  
    return Body;
  }

  const returnRegex = (str: string, type: "MonthlyIncomeStatement" | "MonthlyDirectCashStatement" | "QuarterlyDirectCashStatement" | "QuarterlyIncomeStatement" | "AnnualDirectCashStatement" | "AnnualIncomeStatement") => {
  
    if (type === "MonthlyIncomeStatement" || type === "MonthlyDirectCashStatement") {

        const regex = /(\d{4})-(\d{1,2})\.json$/;
        const matches = str.match(regex);
        const formattedDate = matches ? `${matches[2]}-${matches[1]}` : null;
        
        
        // If you need to pad single digit months with leading zero:
        // const formattedDatePadded = matches ? `${matches[2].padStart(2, '0')}-${matches[1]}` : null;
        return formattedDate
    }

    // else if (type === "QuarterlyDirectCashStatement" || type === "QuarterlyIncomeStatement") {
    //     regex = /(\d{4})-(IV|III|II|I)/g;
    // }

    if (type === 'AnnualDirectCashStatement' || type === "AnnualIncomeStatement") {
        const regex = /(\d{4})\.json$/;
        const matches = str.match(regex);
        const year = matches ? matches[1] : null;

        return year

    } 

    let regex = /(\d{4})-(IV|III|II|I)/g;


    const match = str?.match(regex)?.join("")?.split("-")

    if (match) {
        return `${match[1]}-${match[0]}`
    } else {
        return ""
    }
  }